import { FunctionComponent, useContext } from 'react'
import styled, { css } from 'styled-components'
import contextStandardTeaser from '@contexts/standardTeaser'
import { StandardTeaserLayoutContextType } from '@contexts/standardTeaser'
import { PromoLabelLogoWrapperProps } from '@widgets/Teaser/standard/types'
import { desktopCSS, mobileCSS, tabletCSS } from '@measures/responsive'

type StyledPromoLabelLogoWrapperProps = Pick<
  StandardTeaserLayoutContextType,
  'isInMegaModule'
> &
  Pick<PromoLabelLogoWrapperProps, 'isOnImage'>

const { StandardTeaserLayoutContext } = contextStandardTeaser

const StyledPromoLabelLogoWrapper = styled.div<StyledPromoLabelLogoWrapperProps>`
  ${({ isOnImage, isInMegaModule }) => {
    const basicCSS = css`
      display: flex;
      justify-content: flex-start;
      flex-wrap: wrap;
      align-items: center;
      margin-bottom: 5px;
    `

    const hideCSS = css`
      display: none;
    `

    let cssDesktop
    if (isInMegaModule) {
      if (isOnImage) {
        cssDesktop = css`
          ${hideCSS}
        `
      } else {
        cssDesktop = css`
          ${basicCSS}
        `
      }
    } else {
      if (isOnImage) {
        cssDesktop = css`
          ${basicCSS}
        `
      } else {
        cssDesktop = css`
          ${hideCSS}
        `
      }
    }

    let cssTablet
    if (isInMegaModule) {
      if (isOnImage) {
        cssTablet = css`
          ${hideCSS}
        `
      } else {
        cssTablet = css`
          ${basicCSS}
        `
      }
    } else {
      if (isOnImage) {
        cssTablet = css`
          ${basicCSS}
        `
      } else {
        cssTablet = css`
          ${hideCSS}
        `
      }
    }

    let cssMobile
    if (isOnImage) {
      cssMobile = css`
        ${hideCSS}
      `
    } else {
      cssMobile = css`
        ${basicCSS};
      `
    }

    return css`
      ${desktopCSS(css`
        ${cssDesktop}
      `)}

      ${tabletCSS(css`
        ${cssTablet}
      `)}

      ${mobileCSS(css`
        ${cssMobile}
      `)}
    `
  }}
`

const PromoLabelLogoWrapper: FunctionComponent<PromoLabelLogoWrapperProps> = ({
  isOnImage,
  children,
}) => {
  const { isInMegaModule } = useContext(StandardTeaserLayoutContext)

  return (
    <StyledPromoLabelLogoWrapper
      isOnImage={isOnImage}
      isInMegaModule={isInMegaModule}>
      {children}
    </StyledPromoLabelLogoWrapper>
  )
}

export default PromoLabelLogoWrapper
